import { Box, Typography, useTheme, Checkbox, Paper } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import useResponsive from "../../hooks/useResponsive";
import { useTranslation } from "react-i18next";

interface TaskEditMaterialContainerProps {
  is_removal_task: boolean;
  materialData: any;
  projectData: any;
  displayImage: any
}
const TaskEditMaterialContainer: React.FC<TaskEditMaterialContainerProps> = ({
  is_removal_task,
  materialData,
  projectData,
  displayImage
}) => {

  const theme = useTheme();
  const { isDesktop } = useResponsive()
  const { t } = useTranslation();

  const getMaterialData = () => {
    let value = "Plaats "
    value += (materialData !== null && materialData !== "undefined") ? materialData.material_count : ""
    value += " van "
    value += (materialData !== null && materialData !== "undefined") ? materialData.material_name : ""
    return value;
  }
  const getMaterialDataForOtherTasks = () => {
    if (projectData?.is_removal_task) {
      return t("taskDetails.no_materials_msg")
    } else if (projectData?.is_repair_non_material_task) {
      return t("taskDetails.no_materials_repair_msg")
    } else if (!projectData?.is_removal_task) {
      return getMaterialData()
    }
  }

  return (

    <Paper elevation={3}
      sx={{
        p: 2,
        mt: "25px",
        width: isDesktop ? "90%" : "100%",
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <FiberManualRecord
          sx={{
            color: theme.palette.primary.main,
            fontSize: 8,
            mt: 1,
            mr: 1,
          }}
        />
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <Typography
            fontFamily={"Nunito Sans SemiBold"}
            sx={{
              fontSize: "18px",
              color: theme.palette.primary.main,
            }}
          >
            {getMaterialDataForOtherTasks()}
          </Typography>
          <Typography
            fontFamily="Nunito Sans Regular500"
            fontSize="14px"
            sx={{
              color: theme.palette.primary.main,
            }}
          >
            {projectData?.address}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // Centers items vertically
            gap: 1, // Adds consistent spacing
            ml: 2, // Adds margin from previous content
          }}
        >
          <Typography
            fontFamily="Nunito Sans Regular500"
            sx={{ color: "primary.main", fontSize: "14px" }}
          >
            Uitgevoerd
          </Typography>

          <Checkbox
            checked={displayImage?.length > 0 ? true : false}
            // onChange={(e) => setIsCheck(e.target.checked)}
            sx={{
              color: "primary.main",
              "&.Mui-checked": {
                color: "primary.main",
              },
            }}
            disabled={true}
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default TaskEditMaterialContainer;
